module.exports = __webpack_public_path__ + "img/bb_g3_t_ears-06.e12e42b8.svg";